export default __webpack_public_path__ + "static/media/active-users.f4f46453.svg";